import Konva from "konva";

import { useEffect, useState } from "react";
import { useSceneTransform } from "./services/useSceneTransform";
import { PuzzleManager } from "./components/PuzzleManager";
import { faHighlighter } from "@fortawesome/free-solid-svg-icons";
import { MatchingKeysStrategy } from "./components/check-strategy/MatchingKeysStrategy";
import { CheckStrategy } from "./components/check-strategy/CheckStrategy";
import { AbsolutePositionStrategy } from "./components/check-strategy/AbolutePositionStrategy";
import { SessionType } from "../../../../app/types";
import CanvasControls from "../controls/CanvasControls";

import "./puzzle.scss";

const CheckStrategyResolver: Record<string, CheckStrategy> = {
  MatchingKeys: new MatchingKeysStrategy(),
  AbsolutePosition: new AbsolutePositionStrategy(),
};

const Puzzle = ({
  background,
  puzzleKey,
  pieces: piecesData,
  slots: slotsData,
  availableWidth,
  availableHeight,
  matchingStrategy,
  isFacilitator,
  sessionType,
}: any) => {
  const [puzzleManager, setPuzzleManager] = useState<PuzzleManager | null>(
    null
  );
  const [width, height, scale, offsetX, offsetY] = useSceneTransform(
    availableWidth,
    availableHeight
  );
  const [isChecking, setIsChecking] = useState(false);
  const isSinglePlayer = sessionType === SessionType.Conference;
  const hasSolveBtn = matchingStrategy !== "AbsolutePosition";

  useEffect(() => {
    // console.log(puzzleManager?.checkManager.isChecking);
  }, [puzzleManager?.checkManager.isChecking]);

  useEffect(() => {
    if (puzzleManager) {
      puzzleManager.stage.scaleX(scale);
      puzzleManager.stage.scaleY(scale);
      puzzleManager.stage.width(width);
      puzzleManager.stage.height(height);
      puzzleManager.stage.offsetX(offsetX);
      puzzleManager.stage.offsetY(offsetY);
    }
  }, [width, height, scale, offsetX, offsetY, puzzleManager]);

  useEffect(() => {
    // console.log("UseEffect []");
    var puzzleManager = new PuzzleManager({
      puzzleKey,
      background: background?.data?.attributes,
      piecesData,
      slotsData,
      config: {
        isSinglePlayer: isSinglePlayer,
        showCheckButton: isFacilitator,
        checkStrategy:
          CheckStrategyResolver[matchingStrategy] ?? new MatchingKeysStrategy(),
        setIsChecking,
      },
    });
    setPuzzleManager(puzzleManager);

    return () => {
      puzzleManager.cleanUp();
    };
    // stage.piecesLayer.draw()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="puzzle-container">
      {isFacilitator && (
        <CanvasControls
          restartButtonAction={() => {
            puzzleManager?.pieceManager.resetPositions();
          }}
          mainButtonAction={() => {
            puzzleManager?.checkManager.setCheck(!isChecking);
          }}
          mainButtonIcon={isChecking ? undefined : faHighlighter}
          mainButtonText={isChecking ? "Stop Check" : "Check"}
          solveButtonAction={
            hasSolveBtn
              ? () => {
                  puzzleManager?.slotManager.triggerSolve();
                }
              : undefined
          }
        />
      )}
      <div id={puzzleKey}></div>
    </div>
  );
};

export default Puzzle;
